import React from 'react'

const Cp_sto = () => {
    return (
        <div className='container'>
            <h1>The Stock Span Problem</h1>
            <p>The stock span problem is a financial problem where we have a series of n daily price quotes for a stock and we need to calculate span of stock’s price for all n days. 
            </p>
            <p>
            The span Si of the stock’s price on a given day i is defined as the maximum number of consecutive days just before the given day, for which the price of the stock on the current day is less than or equal to its price on the given day. 
            </p>
            <p>
            For example, if an array of 7 days prices is given as &#123;100, 80, 60, 70, 60, 75, 85&#125;, then the span values for corresponding 7 days are &#123;1, 1, 1, 2, 1, 4, 6&#125; 
            </p>
            <h3>Algorithm</h3>
          <p>
          We see that S[i] on the day i can be easily computed if we know the closest day preceding i, such that the price is greater than on that day than the price on the day i. If such a day exists, let’s call it h(i), otherwise, we define h(i) = -1. 
          </p>
          <p>
          The span is now computed as S[i] = i – h(i).
          </p>
          <p>
          To implement this logic, we use a stack as an abstract data type to store the days i, h(i), h(h(i)), and so on. When we go from day i-1 to i, we pop the days when the price of the stock was less than or equal to price[i] and then push the value of day i back into the stack.
          </p>
          <div class="containers">
        <div class="line number1 index0 alt2"><code
                        class="comment">// C++ linear time solution for stock span problem</code></div>
        <div class="line number2 index1 alt1"><code class="preprocessor">#include &lt;iostream&gt;</code></div>
        <div class="line number3 index2 alt2"><code class="preprocessor">#include &lt;stack&gt;</code></div>
        <div class="line number4 index3 alt1"><code class="library">using</code> <code
                        class="library">namespace</code> <code class="plain">std;</code></div>
        <div class="line number5 index4 alt2">&nbsp;</div>
        <div class="line number6 index5 alt1"><code
                        class="comment">// A stack based efficient method to calculate</code></div>
        <div class="line number7 index6 alt2"><code class="comment">// stock span values</code></div>
        <div class="line number8 index7 alt1"><code class="library">void</code> <code
                        class="plain">calculateSpan(</code><code class="keywords">int</code> <code
                        class="plain">price[], </code><code class="keywords">int</code> <code
                        class="plain">n, </code><code class="keywords">int</code> <code class="plain">S[])</code>
        </div>
        <div class="line number9 index8 alt2"><code class="plain">&#123;</code></div>
        <div class="line number10 index9 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Create a stack and push index of first</code></div>
        <div class="line number11 index10 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// element to it</code></div>
        <div class="line number12 index11 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">stack&lt;</code><code class="keywords">int</code><code
                        class="plain">&gt; st;</code></div>
        <div class="line number13 index12 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(0);</code></div>
        <div class="line number14 index13 alt1">&nbsp;</div>
        <div class="line number15 index14 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Span value of first element is always 1</code></div>
        <div class="line number16 index15 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">S[0] = 1;</code></div>
        <div class="line number17 index16 alt2">&nbsp;</div>
        <div class="line number18 index17 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Calculate span values for rest of the elements</code></div>
        <div class="line number19 index18 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">for</code> <code class="plain">(</code><code class="keywords">int</code>
                <code class="plain">i = 1; i &lt; n; i++) &#123;</code></div>
        <div class="line number20 index19 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Pop elements from stack while stack is not</code></div>
        <div class="line number21 index20 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// empty and top of stack is smaller than</code></div>
        <div class="line number22 index21 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// price[i]</code></div>
        <div class="line number23 index22 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">while</code> <code
                        class="plain">(!st.empty() &amp;&amp; price[st.top()] &lt;= price[i])</code></div>
        <div class="line number24 index23 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.pop();</code></div>
        <div class="line number25 index24 alt2">&nbsp;</div>
        <div class="line number26 index25 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// If stack becomes empty, then price[i] is</code></div>
        <div class="line number27 index26 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// greater than all elements on left of it,</code></div>
        <div class="line number28 index27 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// i.e., price[0], price[1], ..price[i-1].&nbsp; Else</code></div>
        <div class="line number29 index28 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// price[i] is greater than elements after</code></div>
        <div class="line number30 index29 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// top of stack</code></div>
        <div class="line number31 index30 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">S[i] = (st.empty()) ? (i + 1) : (i - st.top());</code></div>
        <div class="line number32 index31 alt1">&nbsp;</div>
        <div class="line number33 index32 alt2"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Push this element to stack</code></div>
        <div class="line number34 index33 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">st.push(i);</code></div>
        <div class="line number35 index34 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">&#125;</code></div>
        <div class="line number36 index35 alt1"><code class="plain">&#125;</code></div>
        <div class="line number37 index36 alt2">&nbsp;</div>
        <div class="line number38 index37 alt1"><code
                        class="comment">// A utility function to print elements of array</code></div>
        <div class="line number39 index38 alt2"><code class="library">void</code> <code
                        class="plain">printArray(</code><code class="keywords">int</code> <code
                        class="plain">arr[], </code><code class="keywords">int</code> <code class="plain">n)</code>
        </div>
        <div class="line number40 index39 alt1"><code class="plain">&#123;</code></div>
        <div class="line number41 index40 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">for</code> <code class="plain">(</code><code class="keywords">int</code>
                <code class="plain">i = 0; i &lt; n; i++)</code></div>
        <div class="line number42 index41 alt1"><code
                        class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">cout &lt;&lt; arr[i] &lt;&lt; </code><code class="string">" "</code><code
                        class="plain">;</code></div>
        <div class="line number43 index42 alt2"><code class="plain">&#125;</code></div>
        <div class="line number44 index43 alt1">&nbsp;</div>
        <div class="line number45 index44 alt2"><code class="comment">// Driver program to test above function</code>
        </div>
        <div class="line number46 index45 alt1"><code class="keywords">int</code> <code class="plain">main()</code>
        </div>
        <div class="line number47 index46 alt2"><code class="plain">&#123;</code></div>
        <div class="line number48 index47 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">price[] = &#123; 10, 4, 5, 90, 120, 80 &#125;;</code>
        </div>
        <div class="line number49 index48 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">n = </code><code
                        class="library">sizeof</code><code class="plain">(price) / </code><code
                        class="library">sizeof</code><code class="plain">(price[0]);</code></div>
        <div class="line number50 index49 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="keywords">int</code> <code class="plain">S[n];</code></div>
        <div class="line number51 index50 alt2">&nbsp;</div>
        <div class="line number52 index51 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// Fill the span values in array S[]</code></div>
        <div class="line number53 index52 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">calculateSpan(price, n, S);</code></div>
        <div class="line number54 index53 alt1">&nbsp;</div>
        <div class="line number55 index54 alt2"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="comment">// print the calculated span values</code></div>
        <div class="line number56 index55 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="plain">printArray(S, n);</code></div>
        <div class="line number57 index56 alt2">&nbsp;</div>
        <div class="line number58 index57 alt1"><code class="undefined spaces">&nbsp;&nbsp;&nbsp;&nbsp;</code><code
                        class="library">return</code> <code class="plain">0;</code></div>
        <div class="line number59 index58 alt2"><code class="plain">&#125;</code></div>
</div>
<div className='output'>
Output <br />
1 1 2 4 5 1
</div>
        </div>
    )
}

export default Cp_sto
